module.exports = __webpack_public_path__ + "img/0-57.9ee10301.jpg";